import { Component } from '@angular/core';

@Component({
  selector: 'pages-layout',
  templateUrl: './pages-layout.component.html',
  styleUrls: ['./pages-layout.component.scss']
})
export class PagesLayoutComponent {

}
